import { render, staticRenderFns } from "./NewCommissionModal.vue?vue&type=template&id=30c27a65&scoped=true&lang=pug"
import script from "./NewCommissionModal.vue?vue&type=script&lang=js"
export * from "./NewCommissionModal.vue?vue&type=script&lang=js"
import style0 from "./NewCommissionModal.vue?vue&type=style&index=0&id=30c27a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c27a65",
  null
  
)

export default component.exports